module.exports = TypeEffect;

function TypeEffect ($el) {
  this.$el = $el;
  this.caption = '';
  this.captionLength = 0;

  _.bindAll(this, 'type', 'erase', 'startTyping', 'startErasing');

  const height = this.$el.height();
  this.$el.empty();
  this.$text = $('<span class="content avoid-shortcuts"></span>').height(height).appendTo(this.$el);
  this.$cursor = $('<span class="cursor">|</span>').appendTo(this.$el);
}

TypeEffect.prototype.hide = function () {
  this.$cursor.hide();
};

TypeEffect.prototype.show = function () {
  this.$cursor.show();
};

TypeEffect.prototype.startTyping = function (caption) {
  this.deferred = $.Deferred();

  this.show();
  this.caption = caption;
  this.captionLength = 0;

  this.type();

  return this.deferred.promise();
};

TypeEffect.prototype.startErasing = function () {
  this.deferred = $.Deferred();

  this.show();
  this.caption = this.$text.text();
  this.captionLength = this.caption.length;

  this.erase();

  return this.deferred.promise();
};

TypeEffect.prototype.type = function () {
  this.$text.html(this.caption || '&nbsp;');
  this.deferred.resolve();
};

TypeEffect.prototype.erase = function () {
  this.$text.html(this.caption.substr(0, this.captionLength--) || '&nbsp;');

  if (this.captionLength >= 0) {
    _.delay(this.erase, 50);
  } else {
    this.captionLength = 0;
    this.caption = '';
    this.deferred.resolve();
  }
};
